import React, {Fragment} from 'react';
import {labels} from '../../../../util/utils';
import Modal from '../../Modal/Modal';
import styled from 'styled-components';
import DocumentName from '../../DocumentName/DocumentName';
import ProgressBar from '../../BaseComponentWrappers/MotifProgressBar';
import {documentNameMaxLength} from '../../../../util/uiconstants';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import FormField from '../../../../components/Common/BaseComponentWrappers/MotifFormField';
import Label from '../../../../components/Common/BaseComponentWrappers/MotifLabel';
import Input from '../../../../components/Common/BaseComponentWrappers/MotifInput';
import ErrorMessage from '../../../../components/Common/BaseComponentWrappers/MotifErrorMessage';

function AddToEvidence({
	isAresView,
	closeError,
	stateDocument,
	textAreaError,
	textAreaErrorMessage,
	handlerTextAreaOnChange,
	onHide,
	onOkClick,
	isLoading,
	entityUId,
	show,
	documentName
}) {
	const loadingIndicatorJsx = isAresView ? (
		<Wrapper className="parentloader">
			<section className="loader">
				<ProgressBar isIndeterminate circle hideLabel isAresView />
				<section className="greywrapper" />
			</section>
		</Wrapper>
	) : (
		<LoadingIndicator show fullscreen={false} view="block" />
	);

	return (
		show && (
			<Modal
				closeBtnTitle={labels.modalCancelTitle}
				closeTitle={labels.modalCloseTitle}
				confirmBtnTitle={labels.addToEvidenceLabel}
				modalContainerClass={isAresView ? 'addtoevicence-modal' : 'add-to-evidence-modal'}
				modalsize="small"
				closeError={closeError}
				onHide={onHide}
				onOkClick={onOkClick}
				show={show}
				showButtons
				title={labels.addToEvidenceLabel}
				isOkButtonDisabled={isLoading}
				isCancelButtonDisabled={isLoading}
			>
				{isLoading && loadingIndicatorJsx}
				<Fragment>
					<section className="addToEvidenceHeading">{labels.addToEvidenceModalDescription}</section>
					<DocumentName
						documentChangeTypeId={stateDocument.documentChangeTypeId}
						documentId={stateDocument.id}
						documentName={stateDocument.documentName}
						documentTypeId={stateDocument.documentTypeId}
						engagementId={stateDocument.engagementId}
						entityUId={entityUId}
						fileExt={stateDocument.fileExt}
						disabled
						isEPSignoffRequired={stateDocument.isEPSignoffRequired}
						isEPSignoffUserRequired={stateDocument.isEPSignoffUserRequired}
						isEQRSignoffRequired={stateDocument.isEQRSignoffRequired}
						isEQRSignoffUserRequired={stateDocument.isEQRSignoffUserRequired}
					/>
					<section className="single-line-text">
						<FormField
							className="addEditAddEvidenceInputField"
							children={
								<>
									<Label>{labels.documentName}</Label>
									<Input
										id="addEvidenceName"
										type="text"
										maxLength={documentNameMaxLength}
										value={documentName || ''}
										onChange={handlerTextAreaOnChange}
										disabled={isLoading}
										hideClearButton={true}
									/>
									{textAreaError && <ErrorMessage message={textAreaErrorMessage} />}
								</>
							}
						/>
						<span className="fileExt">{'.' + stateDocument.fileExt}</span>
					</section>
				</Fragment>
			</Modal>
		)
	);
}

export default AddToEvidence;

const Wrapper = styled.section`
	&.parentloader {
		height: 100%;
		position: absolute;
		width: calc(100% - var(--px-48));
		top: 0;
		pointer-events: all;
		z-index: 999;

		.loader {
			width: 100%;
			height: 100%;
			position: relative;
			z-index: 9999;
			top: var(--px-0);
			height: 100%;
			pointer-events: none;
		}

		.motif-progress-bar-wrapper {
			width: 100%;
			position: relative;
			top: 50%;
			transform: translateY(-50%);
		}

		.greywrapper {
			opacity: 0.5;
			position: absolute;
			pointer-events: none;
			width: 100%;
			z-index: 999;
			background: var(--neutrals-00white);
			height: 100%;
			top: 0;
			pointer-events: none;
		}
	}
`;
